import type { MethodParams } from '../params'
import type { ResultSpec } from '../result'
import type { AnySchema, HandlerBag } from '../types'

// What a generated loader needs from the item it belongs to. Actions, polling triggers and realtime
// triggers can all declare a loader `result`, so this is the narrow contract between them and ../loaders —
// it keeps a loader from having to know which of the three registered it.
//
// All three method classes implement it directly — a loader is handed its owner, not a description of one.

// The generated loader method names. Frozen — these are published method names, derived from the owner's id.
export const sampleResultLoaderName = (ownerId: string): string => `${ ownerId }_SampleResultLoader`
export const dynamicParamsLoaderName = (ownerId: string): string => `${ ownerId }_DynamicParams`

export interface LoaderOwner {
  readonly id: string
  // The owner's grouping label; its loaders inherit it so they sort alongside it.
  readonly category: string
  readonly params: MethodParams
  readonly result: ResultSpec
}

// Only actions declare `dynamicParams`.
export interface DynamicParamsOwner extends LoaderOwner {
  readonly dynamicParamsCriteria: MethodParams
  resolveDynamicParams(bag: HandlerBag & { criteria: Record<string, unknown> }): AnySchema | Promise<AnySchema>
}
